var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',[_c('CCol',{attrs:{"col":"12","lg":"6"}},[_c('CCard',{attrs:{"no-header":""}},[_c('CCardBody',[_c('h3',[_vm._v("Role id: "+_vm._s(_vm.$route.params.id))]),_c('h4',[_vm._v(" Role name: "+_vm._s(_vm.name)+" ")]),_c('CButton',{attrs:{"color":"primary"},on:{"click":_vm.goBack}},[_vm._v("Back")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }